import {fileBaseUrl} from "../../../../../constants";
import {ResourceCardType} from "../resourceCard/resourceCard-helpers";
import {ResourceItemType} from "../resourceList/resourceList-helpers";
import CaringFor from "../../../../../assets/images/svgs/resources/caring_for_someone_with_ga.svg";
import LivingWith from "../../../../../assets/images/svgs/resources/living_with_ga.svg";
import {caringForSomeoneWithGeographicAtrophy, livingWithGeographicAtrophyLeaflet} from "../../../../../assets/data";

export const cardItemList: ResourceCardType[] = [
    {
        image: LivingWith,
        title: "Living With GA",
        filePath: livingWithGeographicAtrophyLeaflet
    },
    {
        image: CaringFor,
        title: "Caring for Someone with GA",
        filePath: caringForSomeoneWithGeographicAtrophy
    }
]

export const styles = {
    resourceCardListWrapper: {
        mt:"38px",
        display:"flex",
        flexDirection:"row",
        justifyContent:"center",
        gap:"24px",
        px:"31px",
    },
    featuredContent: {
        descriptionSx: {
            mt: "38px",
            fontSize: "16.17px",
            color: "#393939",
            letterSpacing:"0%",
            lineHeight: "27px"
        },
        containerBoxSx: {},
        subTitleSx: {
            mt: "38px",
            color: "#A62C4E"
        }
    },
    additionalResources: {
        sectionWrapperSx:{
            backgroundColor: "#F8F8F8",
            pb: "150px"
        },
        descriptionSx: {
            mt: "18px",
            fontSize: "16.17px",
            color: "#393939"
        },
        containerBoxSx: {},
        subTitleSx: {
            mt: "38px",
            color: "#A62C4E"
        }
    }
}

export const additionalResources: ResourceItemType[] = [
    {
        title: "Patient-Doctor Discussion Guide",
        fileUrl: fileBaseUrl + "/static/media/general/pdf/Patient-Doctor Discussion Guide.pdf"
    },
    {
        title: "Understanding and Navigating Your GA",
        fileUrl: fileBaseUrl + "/static/media/general/pdf/Understanding and Navigating Your GA.pdf"
    },
    {
        title: "Living with Dry AMD Brochure",
        fileUrl: fileBaseUrl + "/static/media/general/pdf/Living with Dry AMD Brochure.pdf"
    }
]
